import { getSafeRedirectPath } from "./auth/redirect";

export type PurchasePlanType = "FREE" | "PERSONAL" | "ORGANIZATION";
export type PurchaseCycle = "MONTHLY" | "YEARLY";

export function buildSubscribePath(
  planType: PurchasePlanType,
  cycle: PurchaseCycle = "MONTHLY",
) {
  const params = new URLSearchParams({ plan: planType, cycle });
  return `/subscribe?${params.toString()}`;
}

export function withContinue(path: string, continueTo: string) {
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}continue=${encodeURIComponent(
    getSafeRedirectPath(continueTo, "/account"),
  )}`;
}

export function getOnboardingPath(nextStep: string, continueTo: string) {
  const routeByStep: Record<string, string> = {
    USER_IDENTIFICATION: "/onboarding/user-identification",
    ADDRESS: "/onboarding/address",
    USAGE_PROFILE: "/onboarding/usage-profile",
    WORK_FOCUS: "/onboarding/work-focus",
    CURRENT_TOOLSET: "/onboarding/current-toolset",
    PAIN_POINTS: "/onboarding/user-pain-points",
  };
  return withContinue(
    routeByStep[nextStep] ?? "/onboarding/completion",
    continueTo,
  );
}
